/*
* @prop --uic-check-list-item-height: The height.
*/

uic-check-list-item {
    box-sizing: border-box;
    display: flex;
    align-content: center;
    position: relative;
    height: var(--uic-check-list-item-height);
    padding: 0 8px;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
    outline: none;

    uic-checkbox {
        display: flex;
        width: 100%;
    }

    &:focus-visible {
        border-color: var(--uic-color-blue2);
    }
}

.uic-check-list-item {
    &__content-default {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__content-primary {
        font-weight: var(--uic-font-weight-semibold);
    }

    &__icon {
        display: flex;
        margin-right: 8px;
    }
}

[uic-scroll-init] > uic-check-list-item .uic-checkbox__label {
    padding-left: 20px;
    overflow: visible;
}

uic-check-list-item .uic-checkbox__label {
    display: flex;
    align-items: center;
}
